// Core API - Enhanced Axios Client
// Location: src/core/api/client.ts

import axios, { AxiosInstance } from 'axios';
import { setupInterceptors } from './interceptors';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';
const API_TIMEOUT = 30000; // 30 seconds

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup request/response interceptors
setupInterceptors(apiClient);

export default apiClient;
